import { LanguageType } from '@/custom-types';

export const normalizeDate = (dateString?: string) => {
  if (!dateString) return ''

  // Acepta tanto ISO completo como solo fecha YYYY-MM-DD
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?Z)?$/;

  const isValidDate = isoDateRegex.test(dateString)

  if (isValidDate) return dateString.split('T')[0]

  console.warn('Date is not a valid format, returning an empty string')

  return ''
}

export const advancedNormalizeDate = (userLanguage: LanguageType, dateString?: string) => {
  if (!dateString) return ''

  const parsed = new Date(dateString)

  if (Number.isNaN(parsed.getTime())) {
    console.warn('Date is not a valid format, returning an empty string')
    return ''
  }

  const formatter = new Intl.DateTimeFormat(
    userLanguage === 'es' ? 'es-ES' : 'en-US',
    { dateStyle: 'full' },
  )

  return formatter.format(parsed)
}